import _ from 'lodash';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

import browserHistory from '../../history';
import Api from '../../services/ApiService';
import LoadingPage from '../LoadingPage';
import Form from '../form/Form';
import { modal } from '../modal/ModalEmitter';
import { createItem, updateItem } from '../../actions/DbActions';
import { getPageTitles } from '../../util/page';

class UST4 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isReady: false,
      permissions: {},
      layout: [],
    };

    // keeps track state of roles/allow/deny for each branch
    this.permissionData = {};

    this.itemId = {
      auto: true,
      data: '',
      label: 'id',
      name: 'id',
      hidden: true,
      disabled: true,
    };

    this.form = React.createRef();
    this.systemRoleId = '';
  }

  componentDidMount() {
    this.getLayout();
  }

  getCancelUrl() {
    return '/UST4';
  }

  getPermissionMap(data) {
    return Api.get('permissionmap', {
      params: {
        systemRoleId: data.systemRoleId,
        allow: data.allow.join(','),
        deny: data.deny.join(','),
      },
    }).then(res => {
      this.setState({ permissions: res.data });
    });
  }

  getLayout() {
    const { action, itemId, searchData } = this.props;

    const promise = action === 'new' ? Promise.resolve({}) : Api.get(`db/UST4/${itemId}`);

    return promise.then(res => {
      const data = res.data || {};

      this.systemRoleId = _.get(data, 'systemRoleId', '');
      const systemRoleAllow = _.get(data, 'systemRole.allow', []);

      this.setState({
        layout: [
          {
            name: 'name',
            data: data.name || '',
            label: 'Name',
            type: 'string',
            control: 'Input',
            required: true,
            helpText: `
              Name is for you to help identify and describe role`,
          },
          {
            name: 'systemRoleId',
            data: _.get(data, 'systemRole.id', ''),
            dataAlt: _.get(data, 'systemRole.name', ''),
            label: 'System Role',
            validation: {
              type: 'db',
              modelName: 'systemRole',
              sortBy: 'name',
            },
            helpText: `
              System roles are provided by the application.
              Use them to inherit their permissions.
              As the application adds or removes new pages, system roles are updated automatically.
            `,
          },
          {
            name: 'systemAllow',
            data: systemRoleAllow,
            dataAlt: getPageTitles(systemRoleAllow, searchData),
            label: 'System Allow',
            control: 'Tags',
            disabled: true,
            calculate: true,
            helpText: `
              Allow permissions inherited from selected System Role`,
          },
          {
            type: 'section',
            col: 6,
            fields: [
              {
                name: 'allow',
                data: data.allow || [],
                dataAlt: getPageTitles(data.allow, searchData),
                label: 'Allow',
                control: 'Tags',
                pattern: '^(\\*|[A-Za-z0-9]+\\*?)$',
                validation: {
                  type: 'page',
                  optional: true,
                },
                helpText: `
                  Allow access to specified pages.
                  Use "*" to allow all pages.
                  Use "A*" to allow access to pages that start with A.
                  Use search to grant access to individual pages.`,
              },
            ],
          },
          {
            type: 'section',
            col: 6,
            fields: [
              {
                name: 'deny',
                data: data.deny || [],
                dataAlt: getPageTitles(data.deny, searchData),
                label: 'Deny',
                control: 'Tags',
                pattern: '^(\\*|[A-Za-z0-9]+\\*?)$',
                validation: {
                  type: 'page',
                  optional: true,
                },
                helpText: `
                  Deny access to specified pages.
                  Use "*" to deny all pages.
                  Use "A*" to deny access to pages that start with A.
                  Use search to deny access to individual pages.`,
              },
            ],
          },
        ],
      });

      if (Object.keys(data).length) {
        this.getPermissionMap({
          allow: data.allow || [],
          deny: data.deny || [],
          systemRoleId: data.systemRoleId,
        }).then(() => {
          this.setState({ isReady: true });
        });
      }

      this.setState({ isReady: true });
    });
  }

  getAllowedPermissions() {
    const allowed = [];

    _.each(this.state.permissions, (val, key) => {
      if (val) {
        allowed.push(key);
      }
    });

    return allowed;
  }

  updateItem = payload => {
    const { itemName, itemId } = this.props;
    // transform payload into simple key: value json
    const updateData = {};
    for (const field of payload) {
      if (field.name === 'id') {
        continue;
      }
      updateData[field.name] = field.data;
    }
    return this.props.updateItem(itemName, itemId, updateData);
  };

  createItem = payload => {
    const { itemName } = this.props;

    // transform payload into simple key: value json
    const insertData = {};
    for (const field of payload) {
      insertData[field.name] = field.data;
    }

    return this.props.createItem(itemName, insertData);
  };

  createCallback = response => {
    const { itemName } = this.props;
    const itemId = _.get(response, 'data.id');

    browserHistory.push(`/list/${itemName}/${itemId}/edit`);
  };

  handleChange = ({ form }) => {
    const { layout } = this.state;
    const data = {};
    for (const field of ['allow', 'deny', 'systemRoleId']) {
      data[field] = form[field].data;
    }

    if (data.systemRoleId !== this.systemRoleId) {
      this.systemRoleId = data.systemRoleId;
      Api.get(`db/UST5/${data.systemRoleId}`).then(res => {
        layout.forEach(field => {
          if (field.name === 'systemAllow') {
            const fec = this.form.current.fec.current;

            let value = [];
            if (res.data.allow) {
              const allow = res.data.allow.sort();
              const dataAlt = getPageTitles(allow, this.props.searchData);
              value = fec.manager.encodeFieldValue({ data: allow, dataAlt });
            }
            fec.manager.setData(form).setValue(field.name, value, true);
            fec.syncForm(fec.manager.getData());
          }
        });
      });
    }

    // TODO call only when needed
    this.getPermissionMap(data);
  };

  handleSummaryButton = () => {
    modal.info({
      title: 'Permission Summary',
      message: this.renderPermissions(),
      size: 'lg',
      style: 'top',
    });
  };

  /**
   * Determines what type of action the form is making.
   *
   * @return {Boolean}
   */
  isCreationAction() {
    const { action } = this.props;

    return action === 'new' || action === 'copy';
  }

  renderPermissions() {
    const allowed = this.getAllowedPermissions().sort();

    if (allowed.length === 0) {
      return <div>No permissions specified</div>;
    }

    return allowed.map((perm, i) => {
      const page = this.props.searchData[perm];
      if (!page) {
        // Should not happen but can
        return null;
      }

      return (
        <Col xs={12} sm={6} key={`perm-${i}`}>
          <div style={{ overflow: 'hidden', whiteSpace: 'nowrap' }}>
            <b>{page.name}</b> - {page.title}
          </div>
        </Col>
      );
    });
  }

  render() {
    const { isReady } = this.state;

    if (!isReady) {
      return <LoadingPage />;
    }

    const customActions = [
      {
        label: (
          <span>
            Permission Summary <span className="badge">{this.getAllowedPermissions().length}</span>
          </span>
        ),
        action: this.handleSummaryButton,
        style: 'info',
        title: 'Show all allowed pages (# of pages)',
      },
    ];

    return (
      <Form
        ref={this.form}
        itemName="UST4"
        itemId={this.itemId}
        layout={this.state.layout}
        action={this.props.action}
        submit={this.isCreationAction() ? this.createItem : this.updateItem}
        submitCallback={this.isCreationAction() ? this.createCallback : undefined}
        customActions={customActions}
        onChange={this.handleChange}
        submitAll
        hideCancel
      />
    );
  }
}

UST4.propTypes = {
  itemId: PropTypes.string,
  itemName: PropTypes.string,
  action: PropTypes.string,

  searchData: PropTypes.object,
  createItem: PropTypes.func,
  updateItem: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ createItem, updateItem }, dispatch);
}

function mapStateToProps(state) {
  return {
    searchData: state.app.searchData,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UST4);
